export default "__VITE_ASSET__rDFBLgF1__"